import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
function list_ (obj){
    const keys = ['page', 'limit', 'sortBy', 'sortDir', 'idStore', 'tgl1', 'tgl2','outstand'];
    let str = '';
    for (const key in obj) {
        if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? '&' : '?';
            str += key + '=' + encodeURIComponent(obj[key]);
        }
    }
    if (obj.arrItem && obj.arrItem.length > 0) {
        // const arrItemArry = obj.arrItem
        // for (let index = 0; index < arrItemArry.length; index++) {
        //     const element = arrItemArry[index];
        //     str += str ? '&' : '?';
        //     str += 'arrItem[]' + '=' + element;
        // }   
        str += str ? '&' : '?';
        str = '?arrItem=' + encodeURIComponent(JSON.stringify(obj.arrItem));
    }

    return str;
}

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const str = list_(obj);
                const url = `/inventoryopname${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(obj) {
        console.log('obj',obj)
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post('/inventoryopname', obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/inventoryopname/detail/${obj.invOpnamKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const str = list_(obj);
                axios({
                    url: `/inventoryopname/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'inventory_opname_list.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    posting(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log('do',obj)
                const { data } = await axios.put(`/inventoryopname/posting/${obj.invOpnamDtlKey}`,obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
}